import React, { type SetStateAction } from "react";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@radix-ui/react-dropdown-menu";
import { Check, ChevronDown } from "lucide-react"; // or your own icon
import { useTranslation } from "react-i18next";

export type DropDownOption = {
  option: string;
  label: string;
  onClick: () => void;
};

interface DropDownMenuProps {
  options: DropDownOption[];
  selected: number | string;
  buttonClass?: string;
  menuClass?: string;
  menuItem?: string;
  placeholder?: string;
  button?: React.ReactNode;
  disabled?: boolean;
}

const DropDownMenuComponent: React.FC<DropDownMenuProps> = ({
  options,
  selected,
  buttonClass = "",
  menuClass = "",
  menuItem = "",
  placeholder = "constants.select",
  button,
  disabled = false,
}) => {
  const { t } = useTranslation();

  // console.log(disabled);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger disabled={disabled} asChild>
        {button || (
          <button
            className={`w-full ${
              disabled && "opacity-50"
            } py-[9px] px-[13px] text-base duration-300 text-gray-500 border border-gray-300 font-normal flex items-center justify-between rounded-full ${buttonClass}`}
          >
            {t(`${selected || placeholder}`)}
            <ChevronDown className="ml-2 h-4 w-4 fill-gray-500" />
          </button>
        )}
      </DropdownMenuTrigger>

      <DropdownMenuContent
        side="bottom"
        align="start"
        sideOffset={10}
        style={{ zIndex: 1000 }}
        // className={`w-[148px] bg-white p-1 flex flex-col gap-2 rounded-md animate-in fade-in zoom-in-95 slide-in-from-top-2 duration-200 [&>*]:duration-200 ${menuClass}`}
        className={`bg-white p-1 flex flex-col gap-2 rounded-md duration-200 [&>*]:duration-200 ${menuClass} data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2`}
      >
        {options.map((opt, index) => (
          <DropdownMenuItem
            key={index}
            className={`text-gray-600 font-medium text-base cursor-default hover:text-gray-900 ${menuItem}`}
            onSelect={() => opt?.onClick?.()}
          >
            {t(opt?.label)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default DropDownMenuComponent;
